export default __webpack_public_path__ + "static/media/logo_light.1ff3a1ad.png";